import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    openCart: false,
    openCategories: false,
    openSearchBar: false,
    cart: null,
    cartProducts: [],
    errors: [],
    addons: [],
    comment: "",
    cantidad: 1,
    permitedSubmit: true,
    cartTemporal: [],
    donationProducts: null,
    cartCommerceId: null,
    openCouponModal: false,
    openPromoExceededModal: false,
    lastPromoExceededProduct: null,
    freeProducts: [],
    userValidCoupons: [],
    ordersWithCoupons: [],
    daviviendaBins: [
      360732,
      360000,
      360220,
      360301,
      360320,
      360324,
      360477,
      360480,
      360730,
      360751,
      232002,
      517796,
      524052,
      524708,
      526557,
      526943,
      540692,
      541083,
      541694,
      547130,
      547246,
      547482,
      549156,
      552201,
      552336,
      554531,
      559225,
      527402,
      402530,
      424488,
      424529,
      425817,
      428392,
      439116,
      441080,
      447198,
      448390,
      455981,
      455983,
      455986,
      459321,
      472044,
      485630,
      491646,
      491647,
      455982,
      423150,
      423151,
      475101,
      464815,
      464817,
      464818,
      464819,
      464820,
      464821,
      464822,
      428384,
      428385,
      428386,
      428387,
      428388,
      428389,
      428390,
      428391
    ],
    cartDeledProducts: []
  },
  mutations,
  actions,
  getters
};
